import api from "../Common/Axios/axiosInstanceClient";
import API from "../Common/Endpoint/serviceConstrants";

export const getClientConfigureApi = async () => {
  const { data = {} } = await api.get(API.clientconfiguration);
  return data;
};


